import { TenantType } from '../tenants/index.js';
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["TRIBUNAL"] = "TRIBUNAL";
    FeatureFlag["FILTERV2"] = "FILTERV2";
})(FeatureFlag || (FeatureFlag = {}));
export const FeatureFlagToMeta = {
    [FeatureFlag.TRIBUNAL]: {
        type: 'MODULE',
        name: 'Tribunal module',
        description: 'The tribunal module enables automatic handling of tribunal cases.',
    },
    [FeatureFlag.FILTERV2]: {
        type: 'EXPERIMENTAL',
        name: 'Filter V2',
        description: 'The new filter feature enables easier and faster filtering of data.',
    },
};
const TenantTypeFeatureFlags = {
    [TenantType.Agency]: {
        [FeatureFlag.TRIBUNAL]: true,
    },
    [TenantType.AccountsReceivable]: {},
};
export const hasEnabled = (flag, tenant) => {
    const flags = {
        ...(tenant.type ? TenantTypeFeatureFlags[tenant.type] : {}),
        ...tenant.featureFlags,
    };
    return flags[flag] === true;
};
//# sourceMappingURL=index.js.map